import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    user: null,
    userType: null,
    isUserLoggedIn: false
  },
  mutations: {
    SET_USER_DATA(state, credentials) {
      state.token = credentials.token;
      state.user = credentials;
      state.userType = credentials.role;
      sessionStorage.setItem("setResponse", JSON.stringify(credentials));
      state.isUserLoggedIn = true;
    },
    UPDATE_USER_DATA(state, credentials) {
      let login = JSON.parse(sessionStorage.getItem("setResponse"));
      login.data = credentials;
      state.user = credentials;
      sessionStorage.setItem("setResponse", JSON.stringify(login));
    },
    CLEAR_USER_DATA(state) {
      state.token = null;
      state.user = null;
      state.userType = null;
      state.isUserLoggedIn = false;
      sessionStorage.removeItem("setResponse");
    }
  },
  actions: {
    login({ commit }, credentials) {
      commit("SET_USER_DATA", credentials);
    },
    reloadUserData({ commit }, credentials) {
      commit("SET_USER_DATA", credentials);
    },
    logout({ commit }) {
      commit("CLEAR_USER_DATA");
    },
    updateUserData({ commit }, credentials) {
      commit("UPDATE_USER_DATA", credentials);
    }
  }
});
